import { api } from './client';
import type { OwnershipFilter } from '@shared/types';

export interface ClientForSelector {
  id: number;
  name: string;
  address?: string;
}

export const clientsApi = {
  /**
   * Get clients for selector (from weekly visits)
   * Returns clients the user has access to for the current week
   * Uses 'own' filter by default (same as Visits page)
   */
  getForSelector: async (ownershipFilter?: OwnershipFilter): Promise<ClientForSelector[]> => {
    // Use weekly visits to get available clients with the same filter as Visits page
    const params: Record<string, string> = {};
    if (ownershipFilter) {
      if (Array.isArray(ownershipFilter)) {
        params.ownershipFilter = ownershipFilter.join(',');
      } else {
        params.ownershipFilter = ownershipFilter;
      }
    }
    const { data } = await api.get('/visits/weekly', { params });
    const clients: ClientForSelector[] = data.visits.map((v: { client: ClientForSelector }) => ({
      id: v.client.id,
      name: v.client.name,
      address: v.client.address,
    }));
    // Remove duplicates and sort by name
    const unique = Array.from(
      new Map(clients.map((c) => [c.id, c])).values()
    ).sort((a, b) => a.name.localeCompare(b.name, 'ru'));
    return unique;
  },
};
